module.exports = __webpack_public_path__ + "static/the-cuckoos-egg-119feb8d304e410b9c838927cfabed5c.jpg";